import Lenis from '../vendor/lenis/lenis.mjs';

const initSmoothScroll = () => {
	if (document.body.classList.contains('wp-admin') || window.location.pathname.startsWith('/wp-admin/')) {
		return;
	}

	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
	let lenis = null;

	const syncScrollLock = () => {
		if (!lenis) return;

		const locked = document.body.classList.contains('reference-lightbox-is-open')
			|| document.querySelector('.site-header__toggle[aria-expanded="true"]');

		if (locked && !lenis.isStopped) lenis.stop();
		else if (!locked && lenis.isStopped) lenis.start();
	};

	const update = () => {
		const touchFirst = navigator.maxTouchPoints > 0 && !finePointer.matches;

		if (reducedMotion.matches || touchFirst) {
			lenis?.destroy();
			lenis = null;
			return;
		}

		if (!lenis) {
			// Same Lenis version and motion settings as Creating Websites.
			lenis = new Lenis({
				anchors: true,
				autoRaf: true,
				lerp: 0.16,
				smoothWheel: true,
				stopInertiaOnNavigate: true,
				syncTouch: false,
				wheelMultiplier: 1,
				prevent: (node) => Boolean(node.closest('.reference-lightbox, .site-header__nav, .services-offer__nav-wrap, #wpadminbar, input, textarea, select, [contenteditable="true"], [data-lenis-prevent]')),
				allowNestedScroll: true,
			});
		}

		syncScrollLock();
	};

	const observer = new MutationObserver(syncScrollLock);
	observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
	const menuToggle = document.querySelector('.site-header__toggle');
	if (menuToggle) observer.observe(menuToggle, { attributes: true, attributeFilter: ['aria-expanded'] });

	reducedMotion.addEventListener('change', update);
	finePointer.addEventListener('change', update);
	update();
};

export default initSmoothScroll;
